import { ClientEvent } from '@udemy/event-tracking';

// Placements for the Learning Assistant Entry Point UI
export let LearningAssistantEntryPointUIRegionOptions = /*#__PURE__*/function (LearningAssistantEntryPointUIRegionOptions) {
  LearningAssistantEntryPointUIRegionOptions["LIHP_BANNER"] = "lihp_banner";
  LearningAssistantEntryPointUIRegionOptions["CTP_BANNER"] = "ctp_banner";
  LearningAssistantEntryPointUIRegionOptions["HEADER_NAV"] = "header.nav";
  LearningAssistantEntryPointUIRegionOptions["HEADER"] = "header";
  LearningAssistantEntryPointUIRegionOptions["FLOATING_ACTION_BUTTON"] = "floating_action_button";
  return LearningAssistantEntryPointUIRegionOptions;
}({});

// Types of chats that the Learning Assistant can be used for
export let LearningAssistantChatTypeOptions = /*#__PURE__*/function (LearningAssistantChatTypeOptions) {
  LearningAssistantChatTypeOptions["DISCOVERY_CHAT"] = "discovery_chat";
  LearningAssistantChatTypeOptions["IN_COURSE_CHAT"] = "in_course_chat";
  LearningAssistantChatTypeOptions["SKILLS_CHAT"] = "skills_chat";
  return LearningAssistantChatTypeOptions;
}({});
export class AIAssistantEntryPointPresented extends ClientEvent {
  constructor({
    chatType,
    uiRegion
  }) {
    super('AIAssistantEntryPointPresented');
    this.chatType = void 0;
    this.uiRegion = void 0;
    this.chatType = chatType;
    this.uiRegion = uiRegion;
  }
}
export class AIAssistantEntryPointSelected extends ClientEvent {
  constructor({
    chatType,
    uiRegion
  }) {
    super('AIAssistantEntryPointSelected');
    this.chatType = void 0;
    this.uiRegion = void 0;
    this.chatType = chatType;
    this.uiRegion = uiRegion;
  }
}
//# sourceMappingURL=events.js.map